import { useMutation, useQueryClient } from 'react-query';

import { postNewPosition } from 'api/clients/postNewPosition';

const usePostNewPosition = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: setNewPosition,
    isLoading,
  } = useMutation(postNewPosition, {
    onSuccess: () => {
      queryClient.invalidateQueries('clientsOnMap');
    },
  });

  return {
    isSuccess,
    setNewPosition,
    isLoading,
  };
};

export default usePostNewPosition;
